(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lumecrin-header"]) return;
  try {
    
import('@shopify/events').then(({ StandardEvents }) => {
  if (customElements.get('lumecrin-cart-count')) return;
  class LumecrinCartCount extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      document.addEventListener(StandardEvents.cartLinesUpdate, event => {
        Promise.resolve(event.promise).then(() => this.refresh()).catch(() => {});
      }, options);
      window.addEventListener('pageshow', event => {
        if (event.persisted) this.refresh();
      }, options);
    }

    disconnectedCallback() {
      this.events?.abort();
      this.request?.abort();
    }

    async refresh() {
      if (!this.isConnected) return;
      this.request?.abort();
      const request = new AbortController();
      this.request = request;
      try {
        const response = await fetch(this.dataset.cartUrl, {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' },
          signal: request.signal,
        });
        if (!response.ok) return;
        const cart = await response.json();
        if (!this.isConnected || this.request !== request || !Number.isInteger(cart.item_count) || cart.item_count < 0) return;
        this.querySelector('[data-cart-count]').textContent = String(cart.item_count);
        this.querySelector('a').setAttribute('aria-label', this.dataset.cartLabel.replace('__LUMECRIN_COUNT__', String(cart.item_count)));
      } catch (error) {
        if (error.name !== 'AbortError') return;
      }
    }
  }
  customElements.define('lumecrin-cart-count', LumecrinCartCount);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
